import React from "react";
import { addPdfLinks } from "../helper/newsletterQnAHelper";
import { useNewsletterQnADownload } from "../hooks/useNewsletterQnADownload";

const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" }
];

function NewsletterQnA({
                           onClose,
                           question,
                           setQuestion,
                           fromYear,
                           setFromYear,
                           fromMonth,
                           setFromMonth,
                           thruYear,
                           setThruYear,
                           thruMonth,
                           setThruMonth,
                           answer,
                           loading,
                           error,
                           onSubmit,
                           currentYear,
                           instance,
                           loginRequest
                       }) {
    const { downloadFile } = useNewsletterQnADownload({
        instance,
        loginRequest
    });

    const handleAnswerClick = async (event) => {
        const link = event.target.closest("a[data-pdf-file]");

        if (!link) {
            return;
        }

        event.preventDefault();
        await downloadFile(link.dataset.pdfFile);
    };

    return (
        <div className="newsletter-qna-screen">
            <div className="newsletter-qna-header">
                <h2>Alphaliner Weekly Newsletter Q&amp;A</h2>

                <button className="nav-link" onClick={onClose}>
                    Back
                </button>
            </div>

            <br />

            <p>
                <i>
                    News summarization is provided by a test AI application.
                    Please report inaccuracies or anomalies to{" "}
                    <a href="mailto:itsupport@capps.com">
                        itsupport@capps.com
                    </a>
                    .
                </i>
            </p>

            <br />

            <div className="newsletter-qna-description">
                Ask a question about newsletter content from a selected month
                range.
                <br />
                Example questions:
                <br />

                <ul>
                    <li>
                        As a container leasing company, how should I market to
                        Maersk?
                    </li>

                    <li>
                        As a container leasing company, what is good marketing
                        strategy for Europe?
                    </li>

                    <li>
                        What are the main drivers for trends in the reefer
                        market?
                    </li>
                </ul>
            </div>

            <form
                className="newsletter-qna-card"
                onSubmit={onSubmit}
            >
                <div className="newsletter-qna-controls">
                    <div className="newsletter-qna-range">
                        <label className="newsletter-qna-label">
                            From
                        </label>

                        <div className="newsletter-qna-selectors">
                            <select
                                value={fromMonth}
                                onChange={(event) =>
                                    setFromMonth(
                                        parseInt(event.target.value, 10)
                                    )
                                }
                            >
                                {monthOptions.map((month) => (
                                    <option
                                        key={month.value}
                                        value={month.value}
                                    >
                                        {month.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="number"
                                value={fromYear}
                                min="2024"
                                max={currentYear}
                                onChange={(event) =>
                                    setFromYear(
                                        parseInt(
                                            event.target.value || "0",
                                            10
                                        )
                                    )
                                }
                            />
                        </div>
                    </div>

                    <div className="newsletter-qna-range">
                        <label className="newsletter-qna-label">
                            Through
                        </label>

                        <div className="newsletter-qna-selectors">
                            <select
                                value={thruMonth}
                                onChange={(event) =>
                                    setThruMonth(
                                        parseInt(event.target.value, 10)
                                    )
                                }
                            >
                                {monthOptions.map((month) => (
                                    <option
                                        key={month.value}
                                        value={month.value}
                                    >
                                        {month.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="number"
                                value={thruYear}
                                min="2024"
                                max={currentYear}
                                onChange={(event) =>
                                    setThruYear(
                                        parseInt(
                                            event.target.value || "0",
                                            10
                                        )
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>

                <label
                    className="newsletter-qna-label"
                    htmlFor="newsletter-question"
                >
                    Question
                </label>

                <textarea
                    id="newsletter-question"
                    className="newsletter-qna-input"
                    rows={5}
                    value={question}
                    onChange={(event) =>
                        setQuestion(event.target.value)
                    }
                    placeholder="Ask about shipping industry trends and marketing strategy based on the selected period..."
                />

                <div className="newsletter-qna-actions">
                    <button
                        className="admin-button"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? "Asking..." : "Ask"}
                    </button>
                </div>
            </form>

            {error && (
                <div className="newsletter-qna-error">
                    {error}
                </div>
            )}

            <div className="newsletter-qna-answer">
                <h3>Answer</h3>

                {loading ? (
                    <p>
                        Searching the newsletter knowledge base...
                    </p>
                ) : answer ? (
                    <>
                        <div
                            onClick={handleAnswerClick}
                            dangerouslySetInnerHTML={{
                                __html: addPdfLinks(answer)
                            }}
                        />
                    </>
                ) : (
                    <p className="newsletter-qna-placeholder">
                        Submit a question to see the latest answer here.
                    </p>
                )}
            </div>
        </div>
    );
}

export default React.memo(NewsletterQnA);